import { RootState, UIState } from '@/utils/types/store';
import { ActionContext, Module } from 'vuex';
import names from '@/store/ui/names';

type Ctx = ActionContext<UIState, RootState>;

const initialState: UIState = {
  // Whether the document repo inspection modal is active
  isDocumentInspectionModalActive: false,
};

const uiModule: Module<UIState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: {
    [names.mutations._SET_DOCUMENT_INSPECTION_MODAL](state, isActive) {
      state.isDocumentInspectionModalActive = isActive;
    },
  },
  actions: {
    openDocumentInspectionModal({ commit }: Ctx) {
      commit(names.mutations._SET_DOCUMENT_INSPECTION_MODAL, true);
    },
    closeDocumentInspectionModal({ commit }: Ctx) {
      commit(names.mutations._SET_DOCUMENT_INSPECTION_MODAL, false);
    },
  },
};

export default uiModule;
